import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';
import {
	BOARD_DETAIL_VIEW_MODE,
	DETAIL_VIEW_DEFAULT,
	type DETAIL_VIEW_SIDEBAR,
	type DETAIL_VIEW_MODAL,
	type SwimlaneModeId,
} from './constants';

export { swimlaneModeToStrategies } from './constants';

const localStorage = createLocalStorageProvider('software');

const GROUP_BY_SELECTION = 'gh.groupBySelection.';

type DetailViewMode =
	| typeof DETAIL_VIEW_DEFAULT
	| typeof DETAIL_VIEW_SIDEBAR
	| typeof DETAIL_VIEW_MODAL;

export const setBoardDetailViewMode = (detailViewMode: DetailViewMode) =>
	localStorage.set(BOARD_DETAIL_VIEW_MODE, detailViewMode);

export const getBoardDetailViewMode = (): DetailViewMode =>
	localStorage.get(BOARD_DETAIL_VIEW_MODE) || DETAIL_VIEW_DEFAULT;

export const getSwimlaneModeSetting = (boardId: string): SwimlaneModeId | null | undefined => {
	const data = localStorage.get(`${GROUP_BY_SELECTION}${boardId}`);

	if (!data) {
		return null;
	}

	return data;
};
